<ng-container [formGroup]="imageForm">
  <div fxLayout="row" fxLayoutAlign="beginning center">
    <ng-container *ngIf="!multiple; else multipleImages">
      <button
        *ngIf="!imageForm.controls.image.invalid; else errorSingleButton"
        data-test="addImageButton"
        type="button"
        mat-button
        color="primary"
        (click)="imgFileInput.click()"
      >
        {{ addImageLabel }}
      </button>
      <ng-template #errorSingleButton>
        <button
          type="button"
          mat-button
          color="warn"
          (click)="imgFileInput.click()"
        >
          {{ addImageLabel }}
        </button>
      </ng-template>
      <input
        hidden
        data-test="addImageInput"
        type="file"
        formControlName="image"
        accept="image/*"
        #imgFileInput
      />
      <ng-container *ngIf="imagePreview">
        <img
          [src]="imagePreview"
          height="10%"
          width="10%"
          style="margin: 12px"
        />
      </ng-container>
    </ng-container>
    <ng-template #multipleImages>
      <button
        data-test="addImagesButton"
        *ngIf="imageForm.controls.images.valid; else errorMultipleButton"
        type="button"
        matTooltip="Ajoutez jusqu'à 3 images avec une taille maximale combinée de 1Mo. Insérez les images dans l’ordre souhaité d’apparition"
        mat-button
        color="primary"
        (click)="imgFileInput.click()"
      >
        {{ addImagesLabel }}
      </button>
      <ng-template #errorMultipleButton>
        <button
          type="button"
          mat-button
          color="warn"
          (click)="imgFileInput.click()"
        >
          {{ addImagesLabel }}
        </button>
      </ng-template>
      <input
        hidden
        type="file"
        data-test="addImagesInput"
        formControlName="images"
        multiple="multiple"
        accept="image/*"
        #imgFileInput
      />
      <ng-container *ngFor="let image of images">
        <img
          [src]="image.location"
          height="10%"
          width="10%"
          style="margin: 3px"
        />
        <mat-icon class="cancel" (click)="remove(image)">cancel </mat-icon>
      </ng-container>
    </ng-template>
  </div>
  <div fxLayout="row">
    <br />
    <mat-error
      *ngIf="
        imageForm.controls.images.invalid ||
        imageForm.controls.image.invalid
      "
      >{{ imageTooBigLabel }}
    </mat-error>
  </div>
</ng-container>
